(function () {
    'use strict';

    angular
        .module('app')
        .factory('DmsService', DmsService);

    DmsService.$inject = ['$http', '$q', 'UrlService', 'Upload'];

    function DmsService($http, $q, UrlService, Upload) {

        var service = {
            retrieveFile: retrieveFile,
            getFileMetaData: getFileMetaData,
            saveFile: saveFile,
            deleteFile: deleteFile
        };

        return service;


        /**
         * Save a new file, or update an existing one.
         * File will be updated if it has a non-zero Id.
         *
         * @param {object} fileMetaData
         * @param {File} fileBinary - JS File, https://developer.mozilla.org/en-US/docs/Web/API/File
         *   Optional if updating an existing file.
         *
         * @returns {promise} A promise that resolves if the file was saved successfully.
         *   Promise resolves an {object} representing the new/updated file metadata.
         */
        function saveFile(fileMetaData, fileBinary) {
            var requestUrl = UrlService.getWebAPIUrl() + '/dms';
            var requestMethod = 'POST';

            if (!_.isNil(fileMetaData.Id) && fileMetaData.Id > 0) {
                requestUrl += '/' + fileMetaData.Id;
                requestMethod = 'PUT';
            }

            var savePromise;

            if (_.isNil(fileBinary)) {
                savePromise = $http({
                    method: requestMethod,
                    url: requestUrl,
                    data: fileMetaData
                });
            } else {
                var files = fileBinary;
                if (!Array.isArray(files))
                    files = [files];

                savePromise = Upload.upload({
                    url: requestUrl,
                    data: {
                        files: files,
                        jsonData: angular.toJson(fileMetaData)
                    },
                    method: requestMethod
                });
            }

            return savePromise.then(function (response) {
                return response.data;
            });
        }

        /**
         * Retrieve a file from the DMS
         *
         * @param {number} id - The id of the file
         * @param {bool} saveToFile - Optional. True to open a "Save As" dialog in the browser, default is false.
         *
         * @returns {promise} Promise that resolves an object with the following properties:
         *   - {ArrayBuffer} data
         *   - {string} fileName
         *   - {string} contentType
         */
        function retrieveFile(id, saveToFile) {
            if (_.isNil(saveToFile)) {
                saveToFile = false;
            }

            var req = {
                method: 'GET',
                url: UrlService.getWebAPIUrl() + '/dms/' + id,
                headers: { 'Content-Type': 'application/json' },
                responseType: 'arraybuffer'
            };

            function processResponse(response) {
                var contentDisposition = response.headers('Content-Disposition');

                if (_.isNil(contentDisposition)) {
                    return $q.reject('Server response did not include Content-Disposition.');
                }

                var fileNameParts = contentDisposition.match(/filename[^;\n=]*=((['"]).*?\2|[^;\n]*)/);

                if (_.isNil(fileNameParts) || !fileNameParts.length || fileNameParts.length < 2) {
                    return $q.reject('Server response did not include filename in Content-Disposition.');
                }

                var fileName = fileNameParts[1];
                fileName = fileName.replace(/^"/, '');
                fileName = fileName.replace(/"$/, '');

                return {
                    data: response.data,
                    fileName: fileName,
                    contentType: response.headers('Content-Type')
                };
            }

            var promise = $http(req)
                .then(processResponse);

            if (saveToFile) {
                promise.then(function (response) {
                    var blob = new Blob([response.data], { type: response.contentType });
                    window.saveAs(blob, response.fileName);
                });
            }

            return promise;
        }

        /**
         * Get metadata for the file with the specified id.
         *
         * @param {number} id - The id of the file
         * @returns {promise} 
         */
        function getFileMetaData(id) {
            return $http.get(UrlService.getWebAPIUrl() + '/dms/' + id + '/metadata')
                .then(function (response) {
                    return response.data;
                });
        }

        /**
         * Delete file with the specified id.
         *
         * @param {number} id - The id of the file
         * @returns {promise}
         */
        function deleteFile(id) {
            return $http.delete(UrlService.getWebAPIUrl() + '/dms/' + id);
        }
    }
})();